<template>
  <article
    class="category-block"
    :class="[
      category.layout_type,
      {
        'has-asset': assetSrc && category.asset_key !== 'qr',
        'long-list': category.layout_type !== 'beverages_dual' && (category.products || []).length > 7
      }
    ]"
  >
    <FlagLabel :label="category.badge_label" :icon="category.icon_key" />

    <div v-if="category.layout_type === 'beverages_dual'" class="dual-table">
      <div class="dual-panel">
        <div class="dual-head">
          <span class="dual-head-spacer"></span>
          <span class="dual-head-label dual-head-hot">CALIENTE</span>
          <span class="dual-head-separator">-</span>
          <span class="dual-head-label dual-head-cold">FRIO</span>
        </div>

        <div
          v-for="product in category.products"
          :key="product.id_token"
          class="dual-row"
          :class="{ 'sold-out': product.availability_status === 'sold_out' }"
        >
          <span class="drink-name">{{ product.name }}</span>
          <span class="dual-dots"></span>

          <span v-if="product.availability_status === 'sold_out'" class="dual-sold-out-badge">Agotado</span>
          <span v-else class="drink-price">
            {{ product.has_hot ? formatPrice(product.price_hot) : '-' }}
          </span>

          <span v-if="product.availability_status !== 'sold_out'" class="dual-dots dual-dots-middle"></span>

          <span v-if="product.availability_status !== 'sold_out'" class="drink-price">
            {{ product.has_cold ? formatPrice(product.price_cold) : '-' }}
          </span>
        </div>
      </div>
    </div>

    <div v-else class="simple-list">
      <MenuRow
        v-for="product in category.products"
        :key="product.id_token"
        :name="product.name"
        :price="singlePrice(product)"
        :price-label="product.price_label"
        :status="product.availability_status"
      />
    </div>

    <img
      v-if="assetSrc && category.asset_key !== 'qr'"
      class="category-asset"
      :src="assetSrc"
      alt=""
    />

    <p v-if="category.slug === 'menu-perruno'" class="pet-note">
      Para nuestros mejores amigos &#9825;
    </p>
  </article>
</template>

<script>
import FlagLabel from '@/components/menu/FlagLabel.vue'
import MenuRow from '@/components/menu/MenuRow.vue'

export default {
  name: 'MenuCategoryBlock',
  components: { FlagLabel, MenuRow },
  props: {
    category: { type: Object, required: true },
    formatPrice: { type: Function, required: true },
    assetSrc: { type: String, default: '' }
  },
  methods: {
    singlePrice(product) {
      if (product.price !== null && product.price !== undefined) return product.price
      if (product.price_cold !== null && product.price_cold !== undefined) return product.price_cold
      return product.price_hot
    }
  }
}
</script>

<style scoped>
.category-block {
  position: relative;
  text-align: left;
  padding-bottom: clamp(3px, .28vh, 5px);
}

.category-block + .category-block {
  border-top: 1px dashed rgba(25, 32, 18, .5);
  padding-top: clamp(8px, .62vh, 12px);
}

:deep(.flag-label) {
  min-height: clamp(38px, 2.3vh, 44px);
  padding: clamp(6px, .42vh, 8px) 27px clamp(6px, .42vh, 8px) 17px;
  font-size: clamp(18px, 1.1vh, 22px);
}

:deep(.flag-label)::after {
  right: -20px;
  border-top-width: clamp(19px, 1.15vh, 22px);
  border-bottom-width: clamp(19px, 1.15vh, 22px);
  border-left-width: 20px;
}

.dual-table,
.simple-list {
  margin-top: clamp(8px, .58vh, 11px);
}

/* Bebidas siempre conserva una sola lista: no se divide por cantidad. */
.dual-head,
.dual-row {
  display: grid;
  grid-template-columns:
    minmax(130px, max-content)
    minmax(24px, 1fr)
    64px
    minmax(18px, .65fr)
    64px;
  column-gap: clamp(7px, .85vw, 10px);
}

.dual-head {
  align-items: center;
  margin: 0 0 clamp(6px, .45vh, 9px);
  color: var(--afro-olive);
  font-weight: 900;
  font-size: clamp(12px, .78vh, 15px);
  line-height: 1.05;
  letter-spacing: .02em;
}

.dual-head-spacer { grid-column: 1 / 3; }
.dual-head-label { text-align: center; white-space: nowrap; }
.dual-head-hot { grid-column: 3; }
.dual-head-separator { grid-column: 4; text-align: center; }
.dual-head-cold { grid-column: 5; }

.dual-row {
  align-items: baseline;
  font-size: clamp(16px, .95vh, 18px);
  line-height: 1.15;
}

.drink-name {
  min-width: 0;
  white-space: nowrap;
}

.dual-dots {
  min-width: 16px;
  border-bottom: 2px dotted rgba(33, 30, 23, .38);
  transform: translateY(-4px);
}

.drink-price {
  min-width: 0;
  text-align: right;
  font-weight: 900;
  color: var(--afro-olive);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.dual-row.sold-out .drink-name,
.dual-row.sold-out .dual-dots { opacity: .52; }

.dual-sold-out-badge {
  grid-column: 3 / 6;
  justify-self: start;
  align-self: center;
  display: inline-flex;
  padding: 4px 9px;
  border-radius: 999px;
  background: #b95f57;
  color: #fff8ef;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: .04em;
  text-transform: uppercase;
  white-space: nowrap;
}

/* Postres, frappes y las demas categorias conservan una sola lista. */
.category-block.single_price .simple-list {
  position: relative;
  z-index: 1;
}

.category-block.has-asset.single_price .simple-list {
  padding-right: clamp(122px, 13vw, 150px);
}

.category-block.has-asset.long-list .simple-list { padding-right: 0; }
.category-block.has-asset.long-list .category-asset { width: 96px; opacity: .12; }

.category-block.single_price :deep(.menu-row) {
  grid-template-columns: minmax(0, auto) minmax(24px, 1fr) minmax(50px, max-content);
  font-family: var(--afro-text-serif);
  font-size: clamp(16px, .95vh, 18px);
  line-height: 1.15;
}

.category-block.single_price :deep(.row-name) {
  white-space: normal;
  overflow-wrap: break-word;
}

.category-block.single_price :deep(.row-price) {
  min-width: 50px;
  text-align: right;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.category-block.cold_list :deep(.menu-row),
.category-block.extras :deep(.menu-row) {
  font-size: clamp(16px, .95vh, 18px);
  line-height: 1.15;
}

.category-asset {
  width: min(130px, 30%);
  max-width: 130px;
  max-height: clamp(105px, 12.5vh, 135px);
  object-fit: contain;
  position: absolute;
  right: 0;
  bottom: -4px;
  z-index: 0;
  opacity: .96;
  pointer-events: none;
}

.pet-note {
  position: relative;
  z-index: 1;
  max-width: calc(100% - 150px);
  font-family: cursive;
  color: var(--afro-olive);
  font-size: clamp(17px, 1.05vh, 20px);
  line-height: 1.12;
  margin: 10px 0 0 34px;
  transform: rotate(-6deg);
}

@media (max-width: 900px) {
  .category-block.has-asset.single_price .simple-list { padding-right: 0; }

  .category-block.single_price :deep(.menu-row) {
    font-size: clamp(15px, 4.25vw, 18px);
    line-height: 1.36;
  }

  .category-asset {
    position: static;
    display: block;
    width: auto;
    max-width: 150px;
    max-height: none;
    margin: 10px auto 0;
    opacity: .96;
  }
  .category-block.has-asset.long-list .category-asset { width: auto; opacity: .96; }

  .pet-note {
    max-width: 100%;
    margin-left: 20px;
  }
}

@media (max-width: 520px) {
  .dual-head,
  .dual-row {
    grid-template-columns:
      minmax(104px, 1fr)
      minmax(14px, .55fr)
      46px
      12px
      46px;
    column-gap: 5px;
  }

  .dual-head { font-size: 11px; }
  .dual-row { font-size: 14px; line-height: 1.45; }
  .drink-name { white-space: normal; }
  .dual-dots { min-width: 10px; }
  .dual-dots-middle { opacity: .65; }
  .drink-price { font-size: 13px; }
}
</style>
